export const mainActionsTypes = {
  UPDATE_CURENT_LOCATION: 'UPDATE_CURENT_LOCATION',
  INITIALIZE_TIME: 'INITIALIZE_TIME',
  ADD_NEW_WEATHER_ITEM: 'ADD_NEW_WEATHER_ITEM',
  REMOVE_WEATHER_ITEM: 'REMOVE_WEATHER_ITEM',
  UPDATE_UNIT: 'UPDATE_UNIT',
  UPDATE_ONLY_ONE_LOCATION: 'UPDATE_ONLY_ONE_LOCATION'
};

export const utilsActionsTypes = {
  SHOW_MAP: 'SHOW_MAP',
  HIDE_MAP: 'HIDE_MAP',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
  FILL_CITIES_LIST: 'FILL_CITIES_LIST'
};
